// Formatting for the ABox load dashboard (a_boxes/load_dashboard_controller).
// Data comes from ABoxesController#load_history:
//   { step, from, to, t: [unix...], cpu: [...], cpu_max: [...], ..., totals: { ram_mb, swap_mb, cpu_cores } }
// *_max are there for the rollup resolutions only (1 and 15 minutes).

// "%{name}" interpolation, like Rails I18n
export function translate(text, values = {}) {
  return String(text || '').replace(/%\{(\w+)\}/g, (_, key) => values[key] ?? '')
}

// Rails locale (ua) to a browser one
export function browserLocale(locale) {
  return locale === 'ua' ? 'uk' : (locale || undefined)
}

export function formatNumber(value, digits, locale) {
  if (value == null || Number.isNaN(value)) return '—'
  return value.toLocaleString(browserLocale(locale), { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function lastIndex(values) {
  if (!values) return -1
  for (let index = values.length - 1; index >= 0; index--) if (values[index] != null) return index
  return -1
}

export function lastValue(data, key) {
  const index = lastIndex(data[key])
  return index < 0 ? null : data[key][index]
}

export function max(values) {
  return (values || []).reduce((result, value) => (value != null && (result == null || value > result) ? value : result), null)
}

// "1,9 ГБ" from MB
export function formatMemory(mb, labels, locale) {
  if (mb == null) return null
  return mb >= 1024 ? `${formatNumber(mb / 1024, 1, locale)} ${labels.units.gb}` : `${formatNumber(mb, 0, locale)} ${labels.units.mbytes}`
}

// "5 с", "15 хв"
export function formatStep(step, labels) {
  return step < 60 ? translate(labels.step_seconds, { count: step }) : translate(labels.step_minutes, { count: step / 60 })
}

// Line (and the area under it) of a 0..100 x 0..32 SVG sparkline, broken where values are missing
export function sparkline(values, min, maxValue) {
  const count = values.length
  if (count < 2) return { line: '', area: '' }

  const range = (maxValue - min) || 1
  const x = (index) => (index / (count - 1) * 100).toFixed(2)
  const y = (value) => (32 - (Math.min(Math.max(value, min), maxValue) - min) / range * 30).toFixed(2)

  let line = '', area = '', segment = []
  const closeSegment = () => {
    if (segment.length > 1) area += `M${x(segment[0])} 32` + segment.map((index) => `L${x(index)} ${y(values[index])}`).join('') + `L${x(segment[segment.length - 1])} 32Z`
    segment = []
  }
  values.forEach((value, index) => {
    if (value == null) return closeSegment()
    line += `${segment.length ? 'L' : 'M'}${x(index)} ${y(value)}`
    segment.push(index)
  })
  closeSegment()
  return { line, area }
}

export function escapeHtml(text) {
  return String(text).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]))
}
